var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "error-404-view" } },
    [
      _c("b-container", { staticClass: "space-3" }, [
        _c("div", { staticClass: "mx-auto" }, [
          _c(
            "div",
            { staticClass: "text-center mb-5" },
            [
              _c("div", { staticClass: "title-text mx-auto" }, [
                _vm._v(
                  "\n          Hm, we can't find this page in our flight plan\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-graphics-v2" },
                [
                  _c(_setup.Icon, {
                    staticClass: "display-graphic drone-graphic",
                    attrs: { icon: _setup.faDroneFront },
                  }),
                  _vm._v(" "),
                  _c(_setup.Icon, {
                    staticClass: "display-graphic question-graphic",
                    attrs: { icon: _setup.faQuestion },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle-text h4 mb-5 mx-auto" }, [
                _vm._v(
                  "\n          Sorry for the trouble! Perhaps returning home and taking off from\n          there will help get you where you need to go!\n        "
                ),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-auto mb-5" }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "px-4",
                  attrs: {
                    variant: "outline-primary",
                    size: "lg",
                    pill: "",
                    to: "/",
                  },
                },
                [
                  _vm._v("\n          Return home "),
                  _c(_setup.Icon, {
                    staticClass: "ml-2",
                    attrs: { icon: _setup.faHome },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }